export class Denon500BD {
    constructor(socket, log) {
        this.socket = socket;
        this.power = true;
        this.mediaState = 'stopped';
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /@0\?PW/i,
                callback: (match) => {
                    if (this.power) {
                        this.socket.send(`ack`);
                    }
                },
            },
            {
                name: 'powerSet',
                regExp: /@0PW0(\d)/i,
                callback: (match) => {
                    this.power = match[1] === '1';
                    this.socket.send(`ack`);
                },
            },
            {
                name: 'directionNavigation',
                regExp: /@0PCCUSR(\d+)|@0PCENTR/i,
                callback: (match) => {
                    this.socket.send(`ack`);
                },
            },
            {
                name: 'forwardReverse',
                regExp: /@0PCSLS(R|F)/i,
                callback: (match) => {
                    this.mediaState = match[1] === 'R' ? 'reversing' : 'forwarding';
                    this.socket.send(`@0STDVF${match[1]}`);
                },
            },
            {
                name: 'playStopPause',
                regExp: /@023(\d+)/i,
                callback: (match) => {
                    let response = '';
                    if (match[1] === '53' || match[1] === '32' || match[1] === '33') {
                        // play || next || previous
                        this.mediaState = 'playing';
                        response = '@0STPL';
                    }
                    else if (match[1] === '54') {
                        // stop
                        this.mediaState = 'stopped';
                        // same response as play based on actual device
                        response = '@0STPL';
                    }
                    else if (match[1] === '48') {
                        // pause
                        if (this.mediaState === 'paused') {
                            // if already paused, start playing
                            this.mediaState = 'playing';
                            response = '@0STPL';
                        }
                        else {
                            this.mediaState = 'paused';
                            response = '@0STPP';
                        }
                    }
                    this.socket.send(response);
                },
            },
            {
                name: 'back',
                regExp: /@0PCRTN/i,
                callback: (match) => {
                    this.socket.send(`ack`);
                },
            },
            {
                name: 'info',
                regExp: /@0DVDSIF/i,
                callback: (match) => {
                    this.socket.send(`ack`);
                },
            },
            {
                name: 'menu',
                regExp: /@0PCHM/i,
                callback: (match) => {
                    this.socket.send(`ack`);
                },
            },
            {
                name: 'status',
                regExp: /@0\?ST/i,
                callback: (match) => {
                    let response = '';
                    if (this.mediaState === 'playing') {
                        response = 'ack+@0STPL';
                    }
                    else if (this.mediaState === 'paused') {
                        response = 'ack+@0STPP';
                    }
                    else if (this.mediaState === 'forwarding') {
                        response = 'ack+@0STDVFF';
                    }
                    else if (this.mediaState === 'reversing') {
                        response = 'ack+@0STDVFR';
                    }
                    else if (this.mediaState === 'stopped') {
                        // stopped
                        response = 'ack+';
                    }
                    else {
                        response = 'ack';
                    }
                    this.socket.send(response);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`nack`);
                },
            },
        ];
    }
}
Denon500BD.emulatorType = 'socketEmulator';
Denon500BD.key = '-M_6DFMTlS8jno2tPzoT';
